import type { PatientBillingPrimaryCard } from '@/api/types/PatientApi'
import { UpdateCardModal } from '@/components/BillingPage/UpdateCardModal'
import { HighlightText } from '@/components/HighlightText'
import { Header } from '@/ui/core/header'
import { Skeleton } from '@/ui/core/skeleton'
import { HStack, VStack } from '@/ui/core/stack'

const BillingCardInfo = ({
	primaryCard = {} as PatientBillingPrimaryCard,
	isLoading,
}: { primaryCard: PatientBillingPrimaryCard; isLoading: boolean }) => (
	<VStack className="justify-center items-center h-[45vh] bg-palette_1" gap={20}>
		<Skeleton isLoading={isLoading} className={'h-28 w-3/5 max-w-64'}>
			<HighlightText>Your card</HighlightText>
			<HStack gap={8} className="items-center mb-6">
				<Header variant="h1" className="capitalize">
					{primaryCard?.cardName}
				</Header>
				<Header variant="h1" className="leading-7 native:leading-8">
					...
				</Header>
				<Header variant="h1">{primaryCard?.lastFourDigits}</Header>
			</HStack>
		</Skeleton>
		<UpdateCardModal />
	</VStack>
)

export { BillingCardInfo }
